import React from 'react';
import './OrderOverTimeModal.scss';
import { Modal } from 'antd';
import Button from 'Components/Shared/Button/Button';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  isVisible: boolean;
  onClose: () => void;
}

const OrderOverTimeModal: React.SFC<IProps> = ({
  isVisible,
  onClose,
}) => (
  <Modal
    visible={ isVisible }
    onCancel={ onClose }
    footer={ null }
  >
    <div className='order-over-time-modal'>
      <FormattedText 
        style='title'
        displayName='Tiden för din bokning har gått ut'
        formattedName='order.message.expired.header'
      />
      <FormattedText 
        style='text'
        displayName='Vänligen börja om för att köpa dina biljetter.'
        formattedName='order.message.expired.text'
      />

      <Button onClick={ onClose }>
        <FormattedText
          displayName='Till startsidan'
          formattedName='global.backtostart'
        />
      </Button>
    </div>
  </Modal>
);

export default OrderOverTimeModal;


// WEBPACK FOOTER //
// ./src/components/OrderOverTimeModal/OrderOverTimeModal.tsx